module.exports = __webpack_public_path__ + "static/media/logo.042cfba1.png";